import styles from "../upsc-admission-anna-nagar/upsc-ias-ips-admission.module.css";
import ReCAPTCHA from "react-google-recaptcha";
import { createUser } from "../../components/Service/Userservice";
import { useState } from "react";
import dynamic from 'next/dynamic';
const Otpverification = dynamic(() => import("../../components/Modal/Otpverification"));
const Classroom_form = (props) => {


    const [verified, setverified] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [modalOtp, setModalOtp] = useState(false);
    const [modalOtpstatus, setmodalOtpstatus] = useState(null);
    const [valuephno, setvaluephno] = useState(undefined);
    const [captchaerror, setcaptchaerror] = useState(undefined);
    function onChange(value) {
        if (value == null) {
            setverified(false);
        }
        else {
            setverified(true);
        }
    }

    async function handleOnSubmit(e) {
        e.preventDefault();
        if (verified) {
            const formData = {};
            formData['formType'] = "DelhiScholarshipTest";
            formData['title'] = "Delhi Prefit Scholarship Test";
            formData['branch'] = props.branchname;
            Array.from(e.currentTarget.elements).forEach(field => {
                if (!field.name) return;
                if (field.type === "radio") {
                    if (field.checked) {
                        formData[field.name] = field.value;
                    }
                } else {
                    formData[field.name] = field.value;
                }
            });
            formData['countryCode'] = "+91";
            formData['phoneNo'] = formData['phoneNo'].substring(formData['phoneNo'].indexOf(' ') + 1).trim().replace(/[^0-9]/g, "");
            setIsLoading(true);

            createUser(formData)
                .then(response => {
                    setModalOtp(true);
                    setmodalOtpstatus(response.message);
                    window.grecaptcha.reset(setverified);
                    setverified(false);
                    setvaluephno(undefined);
                    document.getElementById("scholarshipform").reset();
                    setIsLoading(false);
                })
                .catch(error => {
                    setModalOtp(true);
                    setmodalOtpstatus("failure");
                    window.grecaptcha.reset(setverified);
                    setverified(false);
                    setIsLoading(false);
                })

        }
        else {
            setcaptchaerror(true);
            setTimeout(() => {
                setcaptchaerror(false);
            }, 3000);
        }
    }
    return (
        <>

            {isLoading &&
                <div class="APIPreLoader" id="APIPreLoader">
                    <div class="loader">Loading...</div>
                </div>
            }
            <Otpverification show={modalOtp} title={modalOtpstatus} frompage="Delhischolarshiptest" onHide={() => setModalOtp(false)} />
            <div className="">
                <div className="row mx-auto pt-3" style={{ background: "#FFF2F2 0% 0% no-repeat padding-box", opacity: "1" }}>

                    <div className="container pt-4">

                        <div className="row">

                            <div className="col-md-9 col-12 mx-auto">
                                <p className={`${styles.contactheader}`}>Register Now for the Scholarship test</p>
                                <form onSubmit={handleOnSubmit} id="scholarshipform" autoComplete="off">

                                    <div className="row pt-4">

                                        <div className="col-12 col-xl-3 col-lg-4">
                                            <div className="mb-4">
                                                <input type="text" className={`${styles.acheiverrank1} form-control`} placeholder="Name" autoComplete="off" name="name" minLength="1" required />
                                            </div>
                                        </div>

                                        <div className="col-12 col-xl-3 col-lg-4">
                                            <div className="mb-4">
                                                <input type="email" className={`${styles.acheiverrank1} form-control`} placeholder="Email Address" title="Please enter a valid email address" autoComplete="off" name="emailAddress" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$" aria-describedby="emailHelp" required />
                                            </div>
                                        </div>

                                        <div className="col-12 col-xl-3 col-lg-4">
                                            <div className="mb-4">
                                                <input type="tel" className={`${styles.acheiverrank1} form-control`} name="phoneNo" placeholder="Phone No" pattern="[0-9]{10}" maxlength="10" required />
                                            </div>
                                        </div>

                                        <div className="col-12 col-xl-3 col-lg-6 pt-3">

                                            <label className={`${styles.acheiverrank1} form-check-label px-2`}>Mode</label>
                                            <input className="form-check-input" type="radio"
                                                name="mode"
                                                value="Online"
                                                id="Online" />
                                            <label className={`${styles.acheiverrank1} form-check-label px-2`} htmlFor="Online"> Online</label>
                                            <input className="form-check-input" type="radio"
                                                name="mode"
                                                value="Offline"
                                                id="Offline"
                                            />
                                            <label className={`${styles.acheiverrank1} form-check-label px-2`} htmlFor="Offline">Offline</label>
                                        </div>

                                        <div className="col-12 col-xl-6 col-lg-10 pt-3">
                                            <label className={`${styles.acheiverrank1} form-check-label px-2`}>Are you a Shankar IAS Academy student?</label>
                                            <input className="form-check-input" type="radio"
                                                name="oldStudent"
                                                value="Yes"
                                                id="oldStudent"
                                            />
                                            <label className={`${styles.acheiverrank1} form-check-label px-2`} htmlFor="flexRadioDefault5">Yes</label>
                                            <input className="form-check-input" type="radio"
                                                name="oldStudent"
                                                value="No"
                                                id="newStudent"
                                            />
                                            <label className={`${styles.acheiverrank1} form-check-label px-2`} htmlFor="flexRadioDefault6">No</label>
                                        </div>

                                        <div className="col-12 col-xl-6 pt-3">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" value="" id={styles.invalidCheck2} />
                                            <label className={`${styles.checkboxcontent} form-check-label`} htmlFor="invalidCheck2">
                                                I would like to receive updates from Shankar IAS Academy
                                            </label>
                                        </div>


                                        <div className="d-flex flex-wrap mb-3">
                                            <div className="me-3 mt-2">
                                                <ReCAPTCHA className={`${styles.captcha}`}
                                                    sitekey="6LcnfZ0lAAAAAJgHlHwqnKD926Gcgu6jlrHRgMQI"
                                                    onChange={onChange}

                                                />
                                                <div className="">
                                                    {captchaerror && <div className="text-danger text-center captachafont">Please verify the captcha!</div>}
                                                </div>
                                            </div>

                                            <div className="my-auto">
                                                <p className="mt-3"><button className={`${styles.normalbutton}`} type="submit">Send</button></p>
                                            </div>
                                        </div>
                                    </div>

                                    </div>
                                   


                                </form>

                            </div>

                        </div>

                    </div>

                </div>
            </div>

        </>
    )
}
export default Classroom_form;